import { IRequestIO, IResponseIO } from '../core/adapter';
import { AdapterIO, IAdapterIO } from '../core/adapter';
import { TOptions } from '../core/interceptor';
import { t_adapter } from '../core/io';

export type RequestMemory = IRequestIO;
export type ResponseMemory = IResponseIO;

import f1 from'../../../pip/library/pi-f1/pi-f1.js';

/**
 *
 */
export class MemoryAdapterIO
  extends AdapterIO<RequestMemory, ResponseMemory, TOptions>
  implements IAdapterIO<RequestMemory, ResponseMemory, TOptions> {
  type = 'memory' as t_adapter;

  private __memory = new Map<string, unknown>();

  protected async _query(path: string, request: RequestMemory) {
    if (request.signal?.aborted) {
      return { data: null };
    }

    const data = request.data;
    if (f1.is.exists(data)) {
      this.__memory.set(path, data);
    }

    return {
      data: this.__memory.get(path) || null
    } as ResponseMemory;
  }
}
